/** Intake-approved destinations for The Maven microsite (do not substitute placeholders). */

export const MAVEN_HOTEL_HOME_URL = 'https://www.themavenhotel.com/';

export const MAVEN_RESERVATIONS_URL =
	'https://reservations.themavenhotel.com/?_ga=2.261165125.999855957.1773964093-2098059257.1766520432&_gac=1.146698694.1771595247.Cj0KCQiAhtvMBhDBARIsAL26pjGMXKEVkV7CQmpulDIAc1oTTRiLjKmUM7Gx813jsZvzJTTO8HpI1p4aAmfnEALw_wcB&adult=1&arrive=2026-04-01&chain=6052&child=0&currency=USD&depart=2026-04-03&hotel=76320&level=hotel&locale=en-US&productcurrency=USD&rooms=1&shell=RBE&start=availresults&template=RBE';

export const MAVEN_EVENTS_INQUIRY_URL = 'https://www.themavenhotel.com/meetings-events/rfp';

export const MAVEN_SUSTAINABILITY_PAGE_URL = 'https://www.themavenhotel.com/about/mavens-of-sustainability';

export const MAVEN_CAREERS_URL = 'https://www.themavenhotel.com/careers';

export const MAVEN_SALES_MAILTO = 'mailto:sales@themavenhotel.com';

export const MAVEN_FRONT_DESK_MAILTO = 'mailto:FrontDesk@themavenhotel.com';

export const MAVEN_GENERAL_PHONE_TEL = 'tel:7204602727';

export const BIOGREEN360_URL = 'https://biogreen360.com/';
